<template>
    <div :class="clase" style="padding: 40px; border-radius: 10px; margin-bottom: 7px;">
        <div class="row">
          <div class="col-md-12">
            <div class="card-body">
              <center>
                <p style="font-weight: bold; font-size: 1.0rem;">{{ title }}</p>
              </center>
              <center>
                <p class="card-text" style="font-weight: 900; font-size: 3.5rem;">{{ value }}</p>
              </center>
            </div>
          </div>
          <!-- <div class="col-md-4">
            <img
              :src="imgRoute"
              class="img-fluid rounded-start"
              alt="..."
            />
          </div> -->
        </div>
      </div>
</template>
<script>
export default {
    props: {
      value: '',
      imgRoute: '',
      title: '',
      clase: ''
    }
  }
</script>
<style scoped>

.fisioterapia {
    background-color: #5ab4d8;
    color: #063d59;
    border: 5px solid #063d59;
}

.fonoaudiologia {
    background-color: #23bb8f;
    color: #035840;
    border: 5px solid #035840;
}

.terapia_ocupacional {
    background-color: #f2da72;
    color: #a08301;
    border: 5px solid #a08301;
}

.educacion_especial {
    background-color: #d55a5b;
    color: #790505;
    border: 5px solid #790505;
}

.psicologia {
    background-color: #af80c6;
    color: #2a033e;
    border: 5px solid #2a033e;
}

</style>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/cardnominaespecialidad.vue